import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function VendorProfile() {
  const [saving, setSaving] = useState(false);

  const [profile, setProfile] = useState({
    businessName: "",
    vendorType: "",
    gst: "",
    pan: "",
    contact: {
      name: "",
      phone: "",
      email: "",
    },
    bank: {
      accountName: "",
      accountNumber: "",
      ifsc: "",
      bankName: "",
    },
  });

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    const res = await fetch("/api/vendor/profile", {
      credentials: "include",
    });

    const data = await res.json();

    if (data.status === "success") {
      setProfile(data.data);
      console.log(data.data);
    }
  };

  const updateContact = (field, value) => {
    setProfile({
      ...profile,

      contact: {
        ...profile.contact,

        [field]: value,
      },
    });
  };

  const updateBank = (field, value) => {
    setProfile({
      ...profile,

      bank: {
        ...profile.bank,

        [field]: value,
      },
    });
  };

  const saveProfile = async () => {
    setSaving(true);

    try {
      const res = await fetch("/api/vendor/profile", {
        method: "PUT",

        credentials: "include",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(profile),
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Profile updated successfully");
      } else {
        alert(data.message);
      }
    } catch {
      alert("Server Error");
    }

    setSaving(false);
  };

  return (
    <DashboardLayout>
      <div className="space-y-10">
        <div>
          <h1 className="text-2xl font-serif">My Profile</h1>

          <p className="text-sm text-gray-400">
            Manage your business and payment information
          </p>
        </div>

        <Section title="Business Details">
          <ReadOnlyField label="Business Name" value={profile.businessName} />

          <ReadOnlyField label="Vendor Type" value={profile.vendorType} />

          <ReadOnlyField label="GST" value={profile.gst} />

          <ReadOnlyField label="PAN" value={profile.pan} />
        </Section>

        <Section title="Primary Contact">
          <Input
            label="Name"
            value={profile.contact.name}
            onChange={(e) => updateContact("name", e.target.value)}
          />

          <Input
            label="Phone"
            value={profile.contact.phone}
            onChange={(e) => updateContact("phone", e.target.value)}
          />

          <Input
            label="Email"
            value={profile.contact.email}
            onChange={(e) => updateContact("email", e.target.value)}
          />
        </Section>

        <Section title="Bank Details">
          <Input
            label="Account Name"
            value={profile.bank.accountName}
            onChange={(e) => updateBank("accountName", e.target.value)}
          />

          <Input
            label="Account Number"
            value={profile.bank.accountNumber}
            onChange={(e) => updateBank("accountNumber", e.target.value)}
          />

          <Input
            label="IFSC"
            value={profile.bank.ifsc}
            onChange={(e) => updateBank("ifsc", e.target.value)}
          />

          <Input
            label="Bank"
            value={profile.bank.bankName}
            onChange={(e) => updateBank("bankName", e.target.value)}
          />
        </Section>

        <div className="flex justify-end">
          <button
            onClick={saveProfile}
            disabled={saving}
            className="px-8 py-3 rounded-xl bg-amber-400 text-black"
          >
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}

function Section({ title, children }) {
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 p-6">
      <h3 className="text-lg font-serif mb-5">{title}</h3>

      <div className="grid grid-cols-2 gap-4">{children}</div>
    </div>
  );
}

function Input({ label, value, onChange }) {
  return (
    <div>
      <label className="text-xs text-gray-400">{label}</label>

      <input
        value={value}
        onChange={onChange}
        className="w-full mt-1 px-4 py-2 rounded-lg bg-black/40 border border-white/10"
      />
    </div>
  );
}

function ReadOnlyField({ label, value }) {
  return (
    <div>
      <label className="text-xs text-gray-400">{label}</label>

      <div className="mt-1 px-4 py-2 rounded-lg bg-black/60 border border-white/10">
        {value}
      </div>
    </div>
  );
}
